import {DumpsterFire} from "../DumpsterFire";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/reel/winpresentation/SimplePresentationRunner";
import {DumpsterFireGameMode} from "../server/DumpsterFireGameMode";
import {TimelineLite} from "gsap";
import {DumpsterFireModel} from "../server/DumpsterFireModel";

export class DFTotalWinRunner implements SimplePresentation {
    private _tl: TimelineLite;

    shouldRun(): boolean {
        return DumpsterFire.model.winRatio > 0 && DumpsterFire.model.winRatio < DumpsterFireModel.bigWinThresholdReached()
            && ![DumpsterFireGameMode.NORMAL_AVALANCHE, DumpsterFireGameMode.FREESPIN_AVALANCHE].some(mode => DumpsterFire.model.data.nextMode.includes(mode));
    }

    start(controller: SimplePresentationRunnerController): void {
        this._tl = new TimelineLite({
            delay: 0.1,
            onComplete: () => {
                this.complete(controller);
            }
        });
        this._tl.add(() => {
            controller.setSkipCallback(() => this.onSkip(controller));
        }, 0.001);
        let winAmount: number = DumpsterFire.model.gameData.accumulatedRoundWin;
        if (DumpsterFire.model.data.mode.indexOf(DumpsterFireGameMode.FREESPIN) > -1) {
            winAmount = DumpsterFire.model.gameData.spinWin;
        }
        this._tl.add(DumpsterFire.totalWinView.getTotalWinTimeline(winAmount), 0);
    }

    private complete(controller: SimplePresentationRunnerController): void {
        controller.finish();
    }

    private onSkip(controller: SimplePresentationRunnerController): void {
        this._tl?.pause().kill();
        controller.setSkipCallback();
        DumpsterFire.totalWinView.hardAbort();
        this.complete(controller);
    }
}